import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Icon from './Icon';
import { SortIconContainer } from './basicComponents';
import { isHeroBrandEnabled } from '../utils/heroBrandUtils';
import sortIcon from '../images/sortIcon.svg';

const HeroSortIcon = styled.img`
  margin-left: 4px;
  display: inline-flex;
  vertical-align: middle;
`;

/**
 * Column-header sort indicator.
 * Hero brand uses the single sortIcon.svg from the new Translations design;
 * other brands keep the existing two-icon indicator.
 */
const HeaderSortIcon = ({ iconColor }) => {
  if (isHeroBrandEnabled()) {
    return <HeroSortIcon src={sortIcon} alt="" width={18} height={18} />;
  }

  return (
    <SortIconContainer>
      <Icon
        icon="arrows-v"
        iconLib="fontAwesome"
        iconColor={iconColor}
        iconSize={12}
        withoutContainer={true}
      />
      <Icon
        icon="sort"
        iconLib="material"
        iconColor={iconColor}
        iconSize={16}
        withoutContainer={true}
      />
    </SortIconContainer>
  );
};

HeaderSortIcon.propTypes = {
  iconColor: PropTypes.string,
};

export default HeaderSortIcon;
